import { useMutation, useQueryClient } from 'react-query';

import { getDeleteById as deleteTrap } from 'api/traps/deleteTrap';

const useDeleteTrap = () => {
  const queryClient = useQueryClient();
  const {
    isSuccess,
    mutate: getDeleteById,
    isLoading,
  } = useMutation(deleteTrap, {
    onSuccess: () => {
      queryClient.invalidateQueries([
        'useGetSbsTraps',
        'FeromonInsectsTable',
        'ClawingInsectsTable',
        'useGetBsTraps',
        'smartMultiTraps',
      ]);
    },
  });

  return {
    isSuccess,
    getDeleteById,
    isLoading,
  };
};

export default useDeleteTrap;
